import { Breadcrumb, Button, Select, Form, Input } from "antd";
import React, { Component } from "react";
import {
  FaSave,
  FaTimes,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { HomeOutlined } from "@ant-design/icons";

export default class AddTeam extends Component {
  state = {
    loading: false,
  };

  render() {
    const { loading } = this.state;
    return (
      <div className="teams-inner-wrapper">
        <div className="header-img-holder">
          <div className="container">
            <div className="img-header">
              <div className="header-first">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <Link to="/home">
                      <HomeOutlined />
                      <p className="link-name">الرئيسية</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to="/teams">
                      <p className="link-name">الفرق</p>
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="last-bread">
                    اضافه فريق
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h1>اضافه فريق</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="team-crud-wrapper">
          <div className="container">
            <div className="team-crud-content">
              <div className="team-crud-card">
                <h3 className="team-crud-card-title">بيانات الفريق</h3>
                <Form
                  className="form-add-content"
                  layout="vertical"
                  name="nest-messages"
                  onFinish={(values) => this.setState({ depetShow: "list" })}
                >
                  <div className="form-content">
                  <Form.Item
                  label="اسم الفريق"
                  name="customerName"
                  className="input-holder grid-row-full"
                  // rules={[
                  //     {
                  //       required: true,
                  //       message: 'Please input customerʼs Name!',
                  //     },
                  //   ]}
                >
                  <Input placeholder="" />
                </Form.Item>
                  </div>
                  <div className="form-btns-action">
                  <Button
                      className="xlg ml-20"
                      size="large"
                      type="primary"
                      ghost
                      danger
                    >
                      <Link to="/teams">
                      <FaTimes />
                      الغاء
                      </Link>
                    </Button>
                    <Button
                      htmlType="submit"
                      size="large"
                      className="blue-btn xlg"
                      type="primary"
                    >
                      <Link to="/teams">
                      <FaSave />
                      اضافه
                      </Link>
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
